import React from "react";

import SocialMediaData from "../../../AppData/SocialMediaData";
import NavbarData from "../../../AppData/NavbarData";

const Footer = () => {
  return (
    <footer className='bg-primary-dark text-text-light py-16 border-t border-accent-gold/30'>
      <div className='container mx-auto px-6 sm:px-12 md:px-24'>
        {/* Main Footer Content */}
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12'>
          {/* Brand Section */}
          <div className='flex flex-col space-y-4'>
            <h3 className='text-2xl font-serif text-accent-gold font-semibold'>
              Ancy Friz
            </h3>
            <p className='text-text-light/70 font-light'>
              Premium hair salon in Sarajevo, Bosnia and Herzegovina. Expert care and professional styling.
            </p>
            <div className='flex space-x-4'>
              {SocialMediaData.map((social) => (
                <a
                  key={social.id}
                  href={social.link}
                  title={social.title}
                  target="_blank"
                  rel="noreferrer"
                  className='text-accent-gold hover:text-emerald-glow transition-colors duration-300 text-2xl'
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Visit Us Section - With Contact Info */}
          <div className='flex flex-col space-y-4'>
            <h4 className='text-lg font-serif text-accent-gold font-semibold uppercase tracking-wide'>
              Visit Us
            </h4>
            <div className='space-y-2 text-text-light/70 mb-4'>
              <p>Paromlinska 33</p>
              <p>Dolac Malta</p>
              <p>Sarajevo 71000</p>
              <p>Bosnia and Herzegovina</p>
            </div>

            {/* Contact Info - Phone & Email */}
            <div className='flex flex-col lg:flex-row gap-4 lg:gap-6 pt-4 border-t border-accent-gold/20'>
              {/* Phone */}
              <div className='flex flex-col flex-1'>
                <p className='text-xs uppercase tracking-widest text-accent-gold/70 mb-1'>Phone</p>
                <a
                  href='tel:+38762741146'
                  className='text-accent-gold hover:text-emerald-glow transition-colors duration-300 font-medium text-sm'>
                  +387 62 741-146
                </a>
              </div>

              {/* Email */}
              <div className='flex flex-col flex-1'>
                <p className='text-xs uppercase tracking-widest text-accent-gold/70 mb-1'>Email</p>
                <a
                  href='mailto:ancyfriz005@gmail.com'
                  className='text-accent-gold hover:text-emerald-glow transition-colors duration-300 font-medium text-sm break-all'>
                  ancyfriz005@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Working Hours Section */}
          <div className='flex flex-col space-y-4'>
            <h4 className='text-lg font-serif text-accent-gold font-semibold uppercase tracking-wide'>
              Working Hours
            </h4>
            <div className='space-y-2 text-text-light/70'>
              <p><span className='text-accent-gold'>Mon - Sat:</span> 9:00 - 18:00</p>
              <p><span className='text-accent-gold'>Sunday:</span> 10:00 - 14:00</p>
              <p><span className='text-accent-gold font-semibold'>Tuesday:</span> CLOSED</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className='flex flex-col space-y-4'>
            <h4 className='text-lg font-serif text-accent-gold font-semibold uppercase tracking-wide'>
              Quick Links
            </h4>
            <ul className='space-y-2'>
              {NavbarData.slice(0, 4).map((page) => (
                <li key={page.title}>
                  <a
                    href={page.link}
                    className='text-text-light/70 hover:text-accent-gold transition-colors duration-300'>
                    {page.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className='luxury-divider my-12'></div>

        {/* Bottom Footer */}
        <div className='flex flex-col md:flex-row items-center justify-between text-text-light/60 text-sm space-y-6 md:space-y-0'>
          <p className='hidden md:block'>&copy; {new Date().getFullYear()} Ancy Friz. All rights reserved.</p>
          <a href='/privacy-policy' className='hidden md:block hover:text-accent-gold transition-colors duration-300'>
            Privacy Policy
          </a>

          {/* Mobile Footer - Centered */}
          <div className='md:hidden flex flex-col items-center space-y-4 w-full'>
            <p className='text-center'>&copy; {new Date().getFullYear()} Ancy Friz. All rights reserved.</p>
            <div className='flex items-center space-x-2'>
              <span>Powered by</span>
              <a href='https://appwizardpro.com' target='_blank' rel='noreferrer' className='text-accent-gold hover:text-emerald-glow font-semibold transition-colors'>
                App Wizard
              </a>
            </div>
          </div>

          {/* Desktop Footer */}
          <div className='hidden md:flex items-center space-x-2'>
            <span>Powered by</span>
            <a href='https://appwizardpro.com' target='_blank' rel='noreferrer' className='text-accent-gold hover:text-emerald-glow font-semibold transition-colors'>
              App Wizard
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
